module.exports = __webpack_public_path__ + "img/jiaoyu.079866d0.jpg";